// Generated by OrchestKit Claude Plugin
// Created: 2026-09-14

import { useEffect, useState } from 'react';

/**
 * Valeur retardée : ne change qu'après [delai] ms sans nouvelle frappe.
 *
 * Sans elle, chaque lettre tapée dans une recherche partirait en requête —
 * dix appels pour « COT1-VTE-P », dont neuf inutiles sur une connexion lente.
 */
export function useDiffere<T>(valeur: T, delai: number): T {
  const [differee, setDifferee] = useState(valeur);

  useEffect(() => {
    const minuterie = setTimeout(() => {
      setDifferee(valeur);
    }, delai);
    return () => {
      clearTimeout(minuterie);
    };
  }, [valeur, delai]);

  return differee;
}
